import React from 'react';

import styled from 'styled-components';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';

import {
  SHOP_REQUEST_COLUMNS,
  SHOP_REQUEST_TYPE,
  SHOP_REQUEST_TYPE_OPTIONS,
  SHOP_REQUEST_VIEW_GROUP_BY,
} from '../constants';
import { useShopRequestsDataContext } from '../ShopRequestsDataContext';
import { ShopRequestType } from '../types';

const StyledFilter = styled(SelectAdvancedFilter)`
  margin-right: 5px;
`;

const ShopRequestsTypeFilter = () => {
  const { filters, setFilters, setOrdering } = useShopRequestsDataContext();

  const onChange = (selectedRequestTypes: Array<{ value: ShopRequestType }>) => {
    const requestType = selectedRequestTypes.map((type) => type.value);
    const includesOnlySpecialRequestTypes =
      requestType.length > 0 && requestType.every((type) => type !== SHOP_REQUEST_TYPE.MYSTERY_SHOP);
    const shouldEnableRequestGrouping = includesOnlySpecialRequestTypes && filters.groupBy === undefined;

    setFilters({
      ...filters,
      page: 1,
      requestType,
      groupBy: shouldEnableRequestGrouping ? SHOP_REQUEST_VIEW_GROUP_BY.REQUEST : filters.groupBy,
    });

    if (shouldEnableRequestGrouping) {
      setOrdering(SHOP_REQUEST_COLUMNS.requestGroup.id);
    }
  };

  return (
    <StyledFilter
      options={SHOP_REQUEST_TYPE_OPTIONS}
      defaultValue={filters.requestType ?? []}
      onSelect={(types: Array<{ value: ShopRequestType }>) => onChange(types)}
      placeholder="Request Type"
      dataTestId="sr-filter-request-type"
    />
  );
};

export default ShopRequestsTypeFilter;
